import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { LocationServiceException as __BaseException } from "./LocationServiceException";
export class AccessDeniedException extends __BaseException {
    name = "AccessDeniedException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Message = opts.Message;
    }
}
export class ConflictException extends __BaseException {
    name = "ConflictException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.Message = opts.Message;
    }
}
export class InternalServerException extends __BaseException {
    name = "InternalServerException";
    $fault = "server";
    $retryable = {};
    Message;
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerException.prototype);
        this.Message = opts.Message;
    }
}
export class ServiceQuotaExceededException extends __BaseException {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
        this.Message = opts.Message;
    }
}
export class ThrottlingException extends __BaseException {
    name = "ThrottlingException";
    $fault = "client";
    $retryable = {};
    Message;
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.Message = opts.Message;
    }
}
export class ValidationException extends __BaseException {
    name = "ValidationException";
    $fault = "client";
    Message;
    Reason;
    FieldList;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.Message = opts.Message;
        this.Reason = opts.Reason;
        this.FieldList = opts.FieldList;
    }
}
export class ResourceNotFoundException extends __BaseException {
    name = "ResourceNotFoundException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.Message = opts.Message;
    }
}
export const ApiKeyRestrictionsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.AllowReferers && { AllowReferers: SENSITIVE_STRING }),
});
export const CreateKeyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Restrictions && { Restrictions: ApiKeyRestrictionsFilterSensitiveLog(obj.Restrictions) }),
    ...(obj.ExpireTime && { ExpireTime: SENSITIVE_STRING }),
});
export const CreateKeyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const DescribeKeyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
    ...(obj.Restrictions && { Restrictions: ApiKeyRestrictionsFilterSensitiveLog(obj.Restrictions) }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.ExpireTime && { ExpireTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListKeysResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ExpireTime && { ExpireTime: SENSITIVE_STRING }),
    ...(obj.Restrictions && { Restrictions: ApiKeyRestrictionsFilterSensitiveLog(obj.Restrictions) }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListKeysResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListKeysResponseEntryFilterSensitiveLog(item)) }),
});
export const UpdateKeyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ExpireTime && { ExpireTime: SENSITIVE_STRING }),
    ...(obj.Restrictions && { Restrictions: ApiKeyRestrictionsFilterSensitiveLog(obj.Restrictions) }),
});
export const UpdateKeyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const PositionalAccuracyFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Horizontal && { Horizontal: SENSITIVE_STRING }),
});
export const DevicePositionUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
    ...(obj.PositionProperties && { PositionProperties: SENSITIVE_STRING }),
});
export const BatchEvaluateGeofencesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DevicePositionUpdates && {
        DevicePositionUpdates: obj.DevicePositionUpdates.map((item) => DevicePositionUpdateFilterSensitiveLog(item)),
    }),
});
export const BatchEvaluateGeofencesErrorFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
});
export const BatchEvaluateGeofencesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Errors && { Errors: obj.Errors.map((item) => BatchEvaluateGeofencesErrorFilterSensitiveLog(item)) }),
});
export const DevicePositionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.ReceivedTime && { ReceivedTime: SENSITIVE_STRING }),
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
    ...(obj.PositionProperties && { PositionProperties: SENSITIVE_STRING }),
});
export const BatchGetDevicePositionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map((item) => DevicePositionFilterSensitiveLog(item)),
    }),
});
export const CircleFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Center && { Center: SENSITIVE_STRING }),
    ...(obj.Radius && { Radius: SENSITIVE_STRING }),
});
export const GeofenceGeometryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Polygon && { Polygon: obj.Polygon.map((item) => SENSITIVE_STRING) }),
    ...(obj.Circle && { Circle: SENSITIVE_STRING }),
    ...(obj.Geobuf && { Geobuf: SENSITIVE_STRING }),
    ...(obj.MultiPolygon && { MultiPolygon: obj.MultiPolygon.map((item) => item.map((item) => SENSITIVE_STRING)) }),
});
export const BatchPutGeofenceRequestEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) }),
    ...(obj.GeofenceProperties && { GeofenceProperties: SENSITIVE_STRING }),
});
export const BatchPutGeofenceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => BatchPutGeofenceRequestEntryFilterSensitiveLog(item)) }),
});
export const BatchPutGeofenceSuccessFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const BatchPutGeofenceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Successes && { Successes: obj.Successes.map((item) => BatchPutGeofenceSuccessFilterSensitiveLog(item)) }),
});
export const BatchUpdateDevicePositionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Updates && { Updates: obj.Updates.map((item) => DevicePositionUpdateFilterSensitiveLog(item)) }),
});
export const BatchUpdateDevicePositionErrorFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
});
export const BatchUpdateDevicePositionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Errors && { Errors: obj.Errors.map((item) => BatchUpdateDevicePositionErrorFilterSensitiveLog(item)) }),
});
export const CalculateRouteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DeparturePosition && { DeparturePosition: SENSITIVE_STRING }),
    ...(obj.DestinationPosition && { DestinationPosition: SENSITIVE_STRING }),
    ...(obj.WaypointPositions && { WaypointPositions: SENSITIVE_STRING }),
    ...(obj.DepartureTime && { DepartureTime: SENSITIVE_STRING }),
    ...(obj.ArrivalTime && { ArrivalTime: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const LegGeometryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.LineString && { LineString: SENSITIVE_STRING }),
});
export const StepFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.StartPosition && { StartPosition: SENSITIVE_STRING }),
    ...(obj.EndPosition && { EndPosition: SENSITIVE_STRING }),
});
export const LegFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.StartPosition && { StartPosition: SENSITIVE_STRING }),
    ...(obj.EndPosition && { EndPosition: SENSITIVE_STRING }),
    ...(obj.Geometry && { Geometry: LegGeometryFilterSensitiveLog(obj.Geometry) }),
    ...(obj.Steps && { Steps: obj.Steps.map((item) => StepFilterSensitiveLog(item)) }),
});
export const CalculateRouteSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.RouteBBox && { RouteBBox: SENSITIVE_STRING }),
});
export const CalculateRouteResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Legs && { Legs: obj.Legs.map((item) => LegFilterSensitiveLog(item)) }),
    ...(obj.Summary && { Summary: CalculateRouteSummaryFilterSensitiveLog(obj.Summary) }),
});
export const CalculateRouteMatrixRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DeparturePositions && { DeparturePositions: SENSITIVE_STRING }),
    ...(obj.DestinationPositions && { DestinationPositions: SENSITIVE_STRING }),
    ...(obj.DepartureTime && { DepartureTime: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const CalculateRouteMatrixResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SnappedDeparturePositions && { SnappedDeparturePositions: SENSITIVE_STRING }),
    ...(obj.SnappedDestinationPositions && { SnappedDestinationPositions: SENSITIVE_STRING }),
});
export const CreateGeofenceCollectionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const MapConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PoliticalView && { PoliticalView: SENSITIVE_STRING }),
});
export const CreateMapRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Configuration && { Configuration: MapConfigurationFilterSensitiveLog(obj.Configuration) }),
});
export const CreateMapResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const CreatePlaceIndexResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const CreateRouteCalculatorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const CreateTrackerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
});
export const DescribeGeofenceCollectionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const DescribeMapResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Configuration && { Configuration: MapConfigurationFilterSensitiveLog(obj.Configuration) }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const DescribePlaceIndexResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const DescribeRouteCalculatorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const DescribeTrackerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const DeviceStateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
});
export const ForecastedEventFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ForecastedBreachTime && { ForecastedBreachTime: SENSITIVE_STRING }),
    ...(obj.GeofenceProperties && { GeofenceProperties: SENSITIVE_STRING }),
});
export const ForecastGeofenceEventsDeviceStateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
});
export const ForecastGeofenceEventsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DeviceState && { DeviceState: ForecastGeofenceEventsDeviceStateFilterSensitiveLog(obj.DeviceState) }),
});
export const ForecastGeofenceEventsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ForecastedEvents && {
        ForecastedEvents: obj.ForecastedEvents.map((item) => ForecastedEventFilterSensitiveLog(item)),
    }),
});
export const GetGeofenceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
    ...(obj.GeofenceProperties && { GeofenceProperties: SENSITIVE_STRING }),
});
export const ListGeofenceCollectionsResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListGeofenceCollectionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && {
        Entries: obj.Entries.map((item) => ListGeofenceCollectionsResponseEntryFilterSensitiveLog(item)),
    }),
});
export const ListGeofenceResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) }),
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
    ...(obj.GeofenceProperties && { GeofenceProperties: SENSITIVE_STRING }),
});
export const ListGeofencesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListGeofenceResponseEntryFilterSensitiveLog(item)) }),
});
export const PutGeofenceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) }),
    ...(obj.GeofenceProperties && { GeofenceProperties: SENSITIVE_STRING }),
});
export const PutGeofenceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const UpdateGeofenceCollectionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const GetDevicePositionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.ReceivedTime && { ReceivedTime: SENSITIVE_STRING }),
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
    ...(obj.PositionProperties && { PositionProperties: SENSITIVE_STRING }),
});
export const GetDevicePositionHistoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.StartTimeInclusive && { StartTimeInclusive: SENSITIVE_STRING }),
    ...(obj.EndTimeExclusive && { EndTimeExclusive: SENSITIVE_STRING }),
});
export const GetDevicePositionHistoryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map((item) => DevicePositionFilterSensitiveLog(item)),
    }),
});
export const GetMapGlyphsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GetMapSpritesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GetMapStyleDescriptorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GetMapTileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const GetPlaceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const PlaceGeometryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Point && { Point: SENSITIVE_STRING }),
});
export const PlaceFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Geometry && { Geometry: PlaceGeometryFilterSensitiveLog(obj.Geometry) }),
});
export const GetPlaceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) }),
});
export const InferredStateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
});
export const TrackingFilterGeometryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Polygon && { Polygon: obj.Polygon.map((item) => SENSITIVE_STRING) }),
});
export const ListDevicePositionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.FilterGeometry && { FilterGeometry: TrackingFilterGeometryFilterSensitiveLog(obj.FilterGeometry) }),
});
export const ListDevicePositionsResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Accuracy && { Accuracy: PositionalAccuracyFilterSensitiveLog(obj.Accuracy) }),
    ...(obj.PositionProperties && { PositionProperties: SENSITIVE_STRING }),
});
export const ListDevicePositionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListDevicePositionsResponseEntryFilterSensitiveLog(item)) }),
});
export const ListMapsResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListMapsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListMapsResponseEntryFilterSensitiveLog(item)) }),
});
export const ListPlaceIndexesResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListPlaceIndexesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListPlaceIndexesResponseEntryFilterSensitiveLog(item)) }),
});
export const ListRouteCalculatorsResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListRouteCalculatorsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListRouteCalculatorsResponseEntryFilterSensitiveLog(item)) }),
});
export const ListTrackersResponseEntryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CreateTime && { CreateTime: SENSITIVE_STRING }),
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const ListTrackersResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Entries && { Entries: obj.Entries.map((item) => ListTrackersResponseEntryFilterSensitiveLog(item)) }),
});
export const MapConfigurationUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PoliticalView && { PoliticalView: SENSITIVE_STRING }),
});
export const UpdateMapRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ConfigurationUpdate && {
        ConfigurationUpdate: MapConfigurationUpdateFilterSensitiveLog(obj.ConfigurationUpdate),
    }),
});
export const UpdateMapResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const SearchPlaceIndexForPositionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SearchForPositionResultFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) }),
});
export const SearchPlaceIndexForPositionSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Position && { Position: SENSITIVE_STRING }),
});
export const SearchPlaceIndexForPositionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Summary && { Summary: SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj.Summary) }),
    ...(obj.Results && { Results: obj.Results.map((item) => SearchForPositionResultFilterSensitiveLog(item)) }),
});
export const SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Text && { Text: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.FilterBBox && { FilterBBox: SENSITIVE_STRING }),
    ...(obj.FilterCountries && { FilterCountries: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Text && { Text: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.FilterBBox && { FilterBBox: SENSITIVE_STRING }),
    ...(obj.FilterCountries && { FilterCountries: SENSITIVE_STRING }),
});
export const SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Summary && { Summary: SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj.Summary) }),
});
export const SearchPlaceIndexForTextRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Text && { Text: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.FilterBBox && { FilterBBox: SENSITIVE_STRING }),
    ...(obj.FilterCountries && { FilterCountries: SENSITIVE_STRING }),
    ...(obj.Key && { Key: SENSITIVE_STRING }),
});
export const SearchForTextResultFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) }),
});
export const SearchPlaceIndexForTextSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Text && { Text: SENSITIVE_STRING }),
    ...(obj.BiasPosition && { BiasPosition: SENSITIVE_STRING }),
    ...(obj.FilterBBox && { FilterBBox: SENSITIVE_STRING }),
    ...(obj.FilterCountries && { FilterCountries: SENSITIVE_STRING }),
    ...(obj.ResultBBox && { ResultBBox: SENSITIVE_STRING }),
});
export const SearchPlaceIndexForTextResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Summary && { Summary: SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj.Summary) }),
    ...(obj.Results && { Results: obj.Results.map((item) => SearchForTextResultFilterSensitiveLog(item)) }),
});
export const UpdatePlaceIndexResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const UpdateRouteCalculatorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const UpdateTrackerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdateTime && { UpdateTime: SENSITIVE_STRING }),
});
export const VerifyDevicePositionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DeviceState && { DeviceState: DeviceStateFilterSensitiveLog(obj.DeviceState) }),
});
export const VerifyDevicePositionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.InferredState && { InferredState: InferredStateFilterSensitiveLog(obj.InferredState) }),
    ...(obj.SampleTime && { SampleTime: SENSITIVE_STRING }),
    ...(obj.ReceivedTime && { ReceivedTime: SENSITIVE_STRING }),
});
